import React, { HTMLAttributes } from 'react';
import { styled } from 'styled-components';

import useUser from 'hooks/useUser';

const Container = styled.div<{ $size: number }>`
  width: ${(props) => `${props.$size}px`};
  height: ${(props) => `${props.$size}px`};
  min-width: ${(props) => `${props.$size}px`};
  min-height: ${(props) => `${props.$size}px`};
  border-radius: 100%;
  box-shadow: rgba(99, 99, 99, 0.3) 0px 2px 8px 0px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

interface AvatorProps extends HTMLAttributes<HTMLDivElement> {
  size: number;
}

const Avator = React.forwardRef(({ size, ...rest }: AvatorProps, ref: React.ForwardedRef<HTMLDivElement>) => {
  const { data } = useUser();

  return (
    <Container ref={ref} $size={size} {...rest}>
      {data?.userImageUrl && <img src={data.userImageUrl} alt="프로필 이미지" />}
    </Container>
  );
});

export default Avator;
